<template>
    <reconciliation-step-template
        :nextStep="nextStep"
        :previousStep="previousStep"
        @next="goToNextStep"
        @previous="$emit('previous')"
    >
        <template #content>
            <h3>{{ $l10n.__('Débit') }}</h3>
            <p class="fs-3">{{ $l10n.__('Sélectionnez la colonne des débits') }}</p>
            <div class="step-container-table border-black">
                <TableSelectableColumns
                    v-model="modelValue.template.amount_debit.columns"
                    :lines="csv"
                    :max="1"
                />
            </div>
        </template>
    </reconciliation-step-template>
</template>

<script>
import TableSelectableColumns from 'vcomponents/utilities/TableSelectableColumns.vue';
import ImportStepsMixins from './ImportStepsMixins';
export default {
    components: {
        TableSelectableColumns,
    },
    mixins: [ImportStepsMixins],
    data() {
        return {};
    },
    created() {
        this.checkPreviousSteps();
    },
    methods: {
        goToNextStep() {
            this.checkMinColumns('amount_debit', 1) ? this.$emit('next') : false;
        },
    },
};
</script>
